<template>
  <div class="user-message">
    <UserTitle title="消息通知" :border="true"></UserTitle>
    <div class="spin-margin" v-if="loading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
      </a-spin>
    </div>
    <div v-if="!loading">
      <div v-if="messageData.data && messageData.data.length > 0">
        <div class="message-content">
          <div
            class="message-context"
            v-for="(item, index) in messageData.data"
            :key="index"
            @click="goProject(item.objectType,item.objectId)"
          >
            <div class="message-title">
              <i></i>
              <p v-html="item.message"></p>
            </div>
            <span>
              {{ $moment(item.createTime).format("YYYY-MM-DD hh:mm:ss") }}
            </span>
          </div>
        </div>
        <b-pagination
          v-if="page.show"
          class="ltitle-page solution-page"
          style="justify-content: center;"
          v-model="page.current"
          :total-rows="page.rows"
          :perPage="page.perPage"
          first-number
          last-number
        ></b-pagination>
      </div>
      <a-empty class="empty" description="暂无消息" v-else />
    </div>
  </div>
</template>
<script>
import Api from "@/apis";
import publicChange from "@/assets/js/index.js";
export default {
  data() {
    return {
      messageData: [],
      page: {
        current: 1,
        rows: 1,
        perPage: 10,
        show: false
      },
      loading: false
    };
  },
  watch: {
    "page.current": {
      handler: function() {
        this.getData();
        window, scrollTo(0, 0);
      }
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    //处理返回的消息
    messageChange(text) {
      return publicChange.parseRemindMessage(text);
    },
    async getData() {
      this.loading = true;
      const tis = await Api.User.getUserDetail();
      // console.log(data)
      try {
        let query = {
          pageSize: this.page.perPage,
          current: this.page.current,
           senderId: tis.id
        };
        const data = await Api.Reminds.getMessge(query);
        if (data.data && data.data.length > 0) {
          this.page.show = true;
        } else {
          this.page.show = false;
        }
        this.loading = false;
        this.page.rows = data.total;
        this.messageData = data;
      } catch (e) {
        console.log(e);
      }
    },
    goProject(type,id) {
      if(type=='project'){
        this.$router.push({
          path: `/product/projectDetails`,
          query: {
            id: id
          }
        });
      }
      // else if(type=='comment'){
      //   this.$router.push({
      //     path: `/new/details?id=${id}`,
      //     query: {
      //       id: id
      //     }
      //   });
      // }
      else{
        this.$message.warning('仅能查看 项目机会 的详情!')
      }
      
      
    }
  }
};
</script>
<style scoped>
.message-content {
  margin-top: 40px;
  text-align: left;
}
.message-context {
  padding: 28px 24px;
  background: #fbfcff;
  cursor: pointer;
}
.message-context:nth-child(2n) {
  background: #fff;
}
.message-title i {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #96bfff;
}
.message-title {
  display: flex;
  align-items: center;
}
.message-title p {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  margin-left: 17px;
}
.message-context span {
  font-size: 14px;
  font-weight: 400 !important;
  color: #999999;
  line-height: 16px;
  margin-left: 26px;
  margin-top: 9px !important;
  display: inline-block;
}
</style>
